export const STORAGE_LOCALE_KEY = 'locale';
export const WELCOME_EMAIL = 'welcomeEmail';
export const PWD_EXPIRY_RESPONSE_DATA = 'expireLoginResponseData';
export const DOMAIN_NAME = 'domainName';
export const ALL_ENTITIES_COUNT_LIMIT = 'allEntitiesCountLimit';
